var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSkateboarding({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "rotate(-45 40.692 18.205)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E5BF8E",
    d: "M16.711 18.854c.745 0 1.349.602 1.349 1.346l-.001.93-7.81 0 .001-.93c0-.7.535-1.275 1.219-1.34l.13-.006Zm13.051-16.576 0 .931c0 1.945 1.579 3.522 3.527 3.522l1.466 0 0 9.947-1.466 0c-1.948 0-3.527 1.577-3.527 3.522l0 .93-9.525 0 .001-.93c0-1.88-1.475-3.416-3.333-3.516l-.194-.006-1.467 0 0-9.947 1.467 0c1.948 0 3.527-1.577 3.527-3.522l-.001-.931 9.525 0Zm8.64 16.576c.744 0 1.348.602 1.348 1.346l0 .93-7.81 0 0-.93c0-.7.535-1.275 1.219-1.34l.13-.006Zm-30.331-16.478 0 .833c0 1.945 1.58 3.522 3.527 3.522l1.467 0 0 9.947-1.467 0c-1.947 0-3.526 1.577-3.526 3.522l-.001.833c-4.565-.662-8.071-4.586-8.071-9.328 0-4.742 3.506-8.667 8.071-9.329Zm41.923 8.99.006.339c0 4.742-3.506 8.666-8.071 9.328l0-.833c0-1.945-1.58-3.522-3.527-3.522l-1.468 0 0-9.947 1.468 0c1.947 0 3.526-1.577 3.526-3.522l0-.833c4.456.646 7.904 4.4 8.066 8.99Zm-10.244-9.088 0 .931c0 .744-.604 1.347-1.348 1.347l-5.113 0c-.745 0-1.349-.603-1.349-1.347l0-.931 7.81 0Zm-21.691 0 0 .931c0 .744-.603 1.347-1.348 1.347l-5.113 0c-.744 0-1.348-.603-1.348-1.347l-.001-.931 7.81 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M16.711 18.854c.745 0 1.349.602 1.349 1.346l0 .93-7.811 0 .001-.93c0-.69.52-1.26 1.191-1.337l.157-.01 5.113 0Zm7.422-3.441.867.002c3.63 0 6.883-.086 9.758-.259l-.002 1.521-1.467.001c-1.948 0-3.527 1.577-3.527 3.522l0 .93-9.524 0 0-.93c0-1.867-1.455-3.395-3.295-3.514l-.232-.008-1.467-.001-.002-1.594 1.298.09c2.22.138 4.739.225 7.593.24l0 0Zm14.269 3.44c.744 0 1.348.603 1.348 1.347l0 .93-7.81 0 0-.93c0-.69.52-1.26 1.191-1.337l.158-.01 5.113 0Zm-25.338-3.96.002 1.784-1.468.001c-1.947 0-3.526 1.577-3.526 3.522l0 .833c-4.565-.661-8.072-4.586-8.072-9.328.562 0 2.831 2.166 13.064 3.188Zm36.936-3.188c0 4.742-3.507 8.667-8.072 9.328l0-.833c0-1.945-1.579-3.522-3.526-3.522l-1.468-.001 0-1.674c6.757-.55 11.112-1.649 13.066-3.298Z",
    opacity: 0.303
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "m34.496-1.627 2.698 0c.513 0 .93.416.93.929l0 5.952c0 .513-.417.929-.93.929l-2.698 0c-.513 0-.929-.416-.929-.929l0-5.952c0-.513.416-.929.929-.929Z",
    transform: "rotate(90 35.845 2.278)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "m34.496 17.227 2.698 0c.513 0 .93.415.93.928l0 5.953c0 .513-.417.928-.93.928l-2.698 0c-.513 0-.929-.415-.929-.928l0-5.953c0-.513.416-.928.929-.928Z",
    transform: "rotate(90 35.845 21.131)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m34.706 18.366 1.35 0c.512 0 .928.415.928.928l0 5.953c0 .513-.416.928-.929.928l-1.349 0 0 0 0-7.81Z",
    opacity: 0.297,
    transform: "rotate(90 35.845 22.27)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "m12.806-1.627 2.698 0c.513 0 .929.416.929.929l0 5.952c0 .513-.416.929-.929.929l-2.698 0c-.513 0-.93-.416-.93-.929l0-5.952c0-.513.417-.929.93-.929Z",
    transform: "rotate(90 14.155 2.278)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "m12.806 17.227 2.698 0c.513 0 .929.415.929.928l0 5.953c0 .513-.416.928-.929.928l-2.698 0c-.513 0-.93-.415-.93-.928l0-5.953c0-.513.417-.928.93-.928Z",
    transform: "rotate(90 14.155 21.131)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m13.016 18.366 1.35 0c.512 0 .928.415.928.928l0 5.953c0 .513-.416.928-.929.928l-1.35 0 0 0 0-7.81Z",
    opacity: 0.297,
    transform: "rotate(90 14.155 22.27)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkateboarding);
export default __webpack_public_path__ + "static/media/skateboarding.e87d4fd9d95f62948ebec0fdd75347d4.svg";
export { ForwardRef as ReactComponent };